// extracted by mini-css-extract-plugin
module.exports = {"root":"HealthCreateEdit_root__pd1j3"};